import React from "react";
import { DeviceStatusType } from "@common/components/ListDetailViews/DetailView/DeviceCard/const";
import { DeviceCardImageProps } from "@common/components/ListDetailViews/DetailView/DeviceCard/DeviceCardImage";
import { isMeetingFinished } from "@common/utils/meetings";
import {
  ConferenceParticipant,
  ConnectionState,
  MeetingInstance,
  RoomResponse,
} from "@services/meetings/types";
import {
  CheckCircle,
  PersonAddAlt1,
  QuestionMark,
  RemoveCircle,
  ScreenShare,
  SignalCellular1Bar,
  SignalCellular2Bar,
  SignalCellular3Bar,
  SignalCellular4Bar,
  SignalCellularAlt,
} from "@mui/icons-material";

export const getStatus = (
  participant: Pick<ConferenceParticipant, "room" | "status">,
  meeting?: MeetingInstance
): [DeviceStatusType, string] => {
  switch (participant.status) {
    case ConnectionState.Connected || ConnectionState.PartiallyConnected:
      if (isMeetingFinished(meeting)) return ["disconnected", "Disconnecting"];
      if (participant.room?.managed) {
        if (participant.status === ConnectionState.Connected)
          return ["meeting", "Connected"];
        else return ["default", "Partially Connected"];
      }
      return ["default", "Connected Not Monitored"];

    case ConnectionState.Connecting:
      return ["disconnected", "Connecting"];
    case ConnectionState.Disconnected:
      return ["disconnected", "Disconnected"];
    case ConnectionState.Failed:
      return ["error", "Failed"];

    default:
      return ["unknown", "Unknown"];
  }
};
export const getBadgeImage = (
  participant: ConferenceParticipant,
  meeting?: MeetingInstance
): Partial<DeviceCardImageProps> => {
  if (participant === undefined) return {};
  let res: Partial<DeviceCardImageProps> = {};
  let { room, device } = participant;
  if (participant) {
    if (meeting?.scheduledMeeting?.scheduledMeetingRooms) {
      for (const smRoom of meeting?.scheduledMeeting?.scheduledMeetingRooms) {
        if (smRoom.room?.id === room?.id) {
          switch (smRoom.response) {
            case RoomResponse.TENTATIVELYACCEPTED:
              res.topLeftBadge = {
                icon: <QuestionMark />,
                color: "orange",
              };
              break;
            case RoomResponse.ACCEPTED:
              res.topLeftBadge = {
                icon: <CheckCircle />,
                color: "green",
              };
              break;
            case RoomResponse.DECLINED:
              res.topLeftBadge = {
                icon: <RemoveCircle />,
                color: "red",
              };
              break;
            default:
              break;
          }
          break;
        }
      }
    }
    if (!participant.scheduled) {
      res.topRightBadge = {
        icon: <PersonAddAlt1 />,
      };
    }
    if (participant.contentSharing) {
      res.bottomLeftBadge = {
        icon: <ScreenShare />,
      };
    }
    if (
      device &&
      !device?.status?.stale &&
      !device.status?.pauseMonitoringStatus?.paused
    ) {
      switch (device.qualityOfExperience) {
        case 1:
          res.bottomRightBadge = {
            icon: <SignalCellular1Bar />,
            color: "red",
          };
          break;
        case 2:
          res.bottomRightBadge = {
            icon: <SignalCellular2Bar />,
            color: "orange",
          };
          break;
        case 3:
          res.bottomRightBadge = {
            icon: <SignalCellular3Bar />,
            color: "orange",
          };
          break;
        case 4:
          res.bottomRightBadge = {
            icon: <SignalCellular4Bar />,
            color: "green",
          };
          break;
        default:
          res.bottomRightBadge = {
            icon: <SignalCellularAlt />,
            color: "unknown",
          };
          break;
      }
    }
  }
  return res;
};
